<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  background-color: #1a3665 !important;
  color: white !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}
.upload-btn-wrapper {
  width:100%;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  width:50%;

  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>

<template>
  <div class="card">    
    <div
      class="card-header d-flex align-items-center bg-primary font-weight-bold text-white"      
    >
      Artikel
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>    
    <div class="card-body">
      <form @submit.prevent="postData">
        
        <div class="form-row">
          <div class="form-group col-md-12">
            <center>
              <img
                :src="lihat_foto  ? lihat_foto : '/img/placeholder-image.png'"
                style="height:220px"
                class=" img img-responsive elevation-2 border"
                alt="User Picture"
                @error="imgError"
              />
              <br>                  
              <span class="text-danger">*Format Gambar(PNG), Ukuran 500 x 850</span>

              <div class="mt-2">
                <div class="upload-btn-wrapper">
                  <button type="button" class="btn-upload" @click="chooseFiles()"> Unggah Flyer</button>
                  <center>
                    <input type="file" id="fileUpload"  name="myfile" @change="uploadFlyer($event)" ref="refFlyer" />
                  </center>
                </div>
              </div>
            </center>
          </div>
          <div class="form-group col-md-12">
            <label for="name" class="font-weight-bold">Judul</label>
            <input
              type="text"
              class="form-control"
              id="judul"
              placeholder="Masukkan Judul"
              v-model="formData.judul"
              :class="{
                'is-invalid': $v.formData.judul.$error                
              }"
              
            />                        
          </div>          
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="alamat" class="font-weight-bold">Konten</label>
            <textarea
              class="form-control"
              id="isi"
              rows="8"
              placeholder="Masukkan Konten"
              v-model="formData.isi"
              :class="{
                'is-invalid': $v.formData.isi.$error
              }"
            ></textarea>
          </div>
        </div>
        <div class="card-footer bg-white border-0 ml-auto mb-3 pr-0 float-right">          
          <Button
            class="btn btn-md btn-success px-4 py-2"
            type="submit"
          >
            Simpan
          </Button>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import ArtikelService from "@/services/datamaster/artikel.service";
import { required } from "vuelidate/lib/validators";
import { UploadImage } from '@/mixins/UploadImage'
import { AlertUtils } from '@/mixins/AlertUtils'

export default {
  name: "Artikel",
  mixins: [UploadImage, AlertUtils],
  data() {
    return {
      actionPost: "",
      lihat_foto : null,
      formData: {
        judul: "",
        isi: "",
        flyer: null        
      }
    };
  },
  mounted() {
  },
  validations: {
    formData: {
      judul: { required },
      isi: { required },
      flyer: { required },
    }
  },

  methods: {
    imgError(e) {
      e.target.src = '/img/avatars/2.jpeg'
    },

    // uploadFlyer(event) {
    //   var typeDok = event.target.files[0].type;
    //   var typeDokumen = typeDok.split("/");
    //   // comment console console.log(event.target.value)
    //   if (typeDokumen[1] != "png") {
    //     this.alertError("Dokumen Harus Bertipe PNG");
    //     return false;
    //   } else {
    //     this.formData.flyer = event.target.files[0];
    //     this.lihat_foto = event.target.files[0].name;
    //   }
    // },

    chooseFiles: function() {
      document.getElementById('fileUpload').click();
    },
    
    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
    },

    postData() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      } else {          
        this.insertData(this.formData);
      }            
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(formData);
      // comment console console.log("posat");
      ArtikelService.postArtikel(formData)
        .then(response => {
          loader.hide();
          // comment console console.log(response);
          this.$v.$reset();
          this.alertSuccess();
          this.$router.push({ path : "/data-master/artikel" });
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError(error.response.data.message);
        });
    },
  }
};
</script>

<style>
</style>
